import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// 注册Chart.js所需的组件
ChartJS.register(
  CategoryScale, // 分类轴，用于x轴
  LinearScale,   // 线性轴，用于y轴
  BarElement,    // 条形图元素
  Title,         // 图表标题
  Tooltip,       // 鼠标悬停提示
  Legend         // 图例
);

/**
 * 访客图表组件的属性接口。
 * 定义了组件接收的数据结构。
 */
interface VisitorChartProps {
  /**
   * 图表数据，包含日期和对应的访问量。
   * 例如: [{ date: '2023-01-01', count: 100 }]
   */
  data: { date: string; count: number }[];
}

/**
 * 访客图表组件。
 * 使用Bar Chart展示每日访问量。
 * @param {VisitorChartProps} props 组件属性，包含要显示的数据。
 */
const VisitorChart: React.FC<VisitorChartProps> = ({ data }) => {
  // 准备图表所需的数据格式
  const chartData = {
    labels: data.map((item) => item.date), // x轴标签（日期）
    datasets: [
      {
        label: '访问量', // 数据集的标签
        data: data.map((item) => item.count), // y轴数据（访问量）
        backgroundColor: 'rgba(75, 192, 192, 0.6)', // 条形图背景颜色
        borderColor: 'rgba(75, 192, 192, 1)',     // 条形图边框颜色
        borderWidth: 1,                           // 条形图边框宽度
      },
    ],
  };

  // 图表选项配置
  const options = {
    responsive: true, // 响应式布局
    plugins: {
      legend: {
        position: 'top' as const, // 图例位置
      },
      title: {
        display: true,          // 显示标题
        text: '每日访问量统计', // 标题文本
      },
    },
  };

  return (
    <div style={{ width: '80%', margin: 'auto' }}>
      {/* 渲染条形图 */}
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default VisitorChart;